export const theme = {
  colors: {
    primary: "#1E1944",
    title: "#2C2C2E",
    text: "#48484A",
    light: "#E5E5EA",
    white: "#FFFFFF",
    gray: "#636366",
    gray_light: "#D1D1D6",
    primary_light: "#199CD9",
    success: "#1BC035",
    secondary: "#16074A",
    purple: "#6B59A3",
    text_light: "#8E8E93",
    blue_light: "#97dcff",
    gray_bg: "#F7F7F9",
    border_gray: "#e5e5ea",
    danger: "#B00020",
  },
  typography: {
    xTitle: {
      size: 28,
      lineHeight: 32,
    },
    title: {
      size: 20,
      lineHeight: 24,
    },
    subTitle: {
      size: 16,
      lineHeight: 24,
    },
    text: {
      size: 14,
      lineHeight: 20,
    },
    small: {
      size: 12,
      lineHeight: 16,
    },
    link: {
      size: 16,
      lineHeight: 20,
    },
  },
  spacings: {
    small: 8,
    regular: 16,
    medium: 24,
    large: 32,
  },
  fontWeight: {
    bold: 700,
    regular: 400,
  },
};
